import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { recursosBecas } from 'src/app/recursos/interfaz';

@Component({
  selector: 'app-req-general-operario',
  templateUrl: './req-general-operario.component.html',
  styleUrls: ['./req-general-operario.component.css']
})
export class ReqGeneralOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecRequisito = []; public vecAddRequisito = []; public vecBeca = []; public vecDataRequisito = []; public vecFuenteRequisito = []; public vecFormato: any;
  public tituloModal: string; private accion: number; private banBeca = 0; private periodoCod = '';
  private tokenDrive: string = ''; fileReq: any;
  public rutaCarga: SafeResourceUrl | undefined; public enlaceCarga: string = '';

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private srvGeneral: recursosCompartido,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private recBecas: recursosBecas) { }

  async ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarReqGenerales(1);
    this.cargarBecas();
    this.verTodosRequisitos();
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
  }
  //FUNCION QUE CARGA TODAS LAS BECAS
  async cargarBecas() {
    this.vecBeca = [];
    //OBTENER TODAS LAS BECAS REGISTRADAS
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(6, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objBeca of res.becas) {
        this.vecBeca.push({
          codigo: objBeca.intIdBecas, nombre: objBeca.strNombre
        });
      }
    }
  }
  //OBTENER TODOS LOS REQUSITOS REGISTRADOS
  async verTodosRequisitos() {
    this.vecDataRequisito = []; this.vecFuenteRequisito = [];
    //OBTENER TODOS LOS REQUISITOS REGISTRADOS EN LA BASE DE DATOS
    const resGen = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(13, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGen.success)
      this.vecDataRequisito = resGen.especifico;
  }
  //FUNCION QUE CARGA TODOS LOS REQUISITOS GENERALES DEL TIPO DE BECA SELECCIONADO
  async cargarReqGenerales(op) {
    this.cargando.abrir();
    this.reiniciarTabla();
    this.vecRequisito = [];
    //OBTENER EL PERIODO VIGENTE A LA FECHA ACTUAL
    const resPer = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(10, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPer.success) {
      this.periodoCod = resPer.carrera[0]['strCodigo'];

      //OBTENER LAS FUENTES DE LOS REQUISITOS
      const resFuente = await new Promise<any>(resolve =>
        this.srvSelect.gestionRequisitos(15, localStorage.getItem('modBeca'), this.periodoCod, 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resFuente.success)
        this.vecFuenteRequisito = resFuente.especifico;
      //OBTENER TODOS LOS REQUISITOS GENERALES
      const resGen = await new Promise<any>(resolve => this.srvSelect.gestionRequisitos(3, this.periodoCod, "na", "na").subscribe(translated => { resolve(translated) }));
      if (resGen.success) {
        for (let objGen of resGen.especifico) {
          if (op == 1) {
            if (objGen.genEstado == 1)
              this.vecRequisito.push({ general: objGen });
          }
          else
            this.vecRequisito.push({ general: objGen });
        }
      }
      else
        this.obtenerRequisitos();
    }
    else
      this.alerti.warning('A la fecha actual no hay período académico vigente');
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION QUE OBTIENE LOS ULTIMOS REQUISITOS SUBIDOS PARA UN TIPO DE BECA
  async obtenerRequisitos() {
    const resReq = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(13, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resReq.success) {
      this.srvInsert.ingresoGestionRequisitos(resReq.especifico, this.periodoCod, localStorage.getItem('ciUsuario'),
        'na', 'na', 'na', 'na', 1, 9).subscribe(res => {
          if (res.requisito) {
            this.reiniciarTabla();
            this.cargarReqGenerales(1);
          }
        });
    }
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN REQUISITO GENERAL
  modalNuevoRequisito(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = "Ingresar un requisito General"; this.accion = 3;
      this.instanciaRequisito(0, '', '', 1, this.periodoCod, 2, localStorage.getItem('ciUsuario'), '', 1);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN REQUISITO
  modalModRequisito(nameMod, objReq) {
    if (localStorage.getItem('modUser') == 'true') {
      this.tituloModal = "Modificar el requisito"; this.accion = 6;
      this.instanciaRequisito(objReq.reqId, objReq.reqNombre, objReq.reqDetalle, objReq.genEstado, objReq.genPeriodo, objReq.becaId, objReq.genRegistro,
        '', objReq.intIdFuente);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE ABRE EL MODAL PARA MIGRAR REQUISITOS ESPECIFICOS
  verModMigraRequisito(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.instanciaRequisito(0, '', '', 1, this.periodoCod, 2, localStorage.getItem('ciUsuario'), '', 1);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE PERMITE AGREGAR O EDITAR UN REQUISITO GENERAL
  agregarRequisito() {
    this.srvInsert.ingresoGestionRequisitos(this.vecAddRequisito[0]['idReq'], this.vecAddRequisito[0]['nombre'], this.vecAddRequisito[0]['detalle'],
      this.vecAddRequisito[0]['estado'], this.vecAddRequisito[0]['periodo'], this.vecAddRequisito[0]['beca'], localStorage.getItem('ciUsuario'),
      this.vecAddRequisito[0]['tipoReq'], this.accion).subscribe(res => {
        if (res.requisito) {
          if (this.accion == 3) {

            this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'ingresoGestionRequisitos()', 'iNGRESAR / EDITAR un requisito general',
              this.accion, ' Id_Req_Gen - ' + this.vecAddRequisito[0]['idReq'] + '; Nombre_Req_Gen - ' + this.vecAddRequisito[0]['nombre'] + '; Detalle_Req_Gen - ' +
              this.vecAddRequisito[0]['detalle'] + '; Estado_Req_Gen - ' + this.vecAddRequisito[0]['estado'], 1).subscribe(res => { });
            this.cerrarModal();
          }
          this.reiniciarTabla();
          this.cargarReqGenerales(1);

          this.alerti.success('Requisito ingresado correctamente');
        }
        else
          this.alerti.error("No se pudo registrar la información.");
      });
  }
  //FUNCION PARA MODIFICAR EL ESTADO DE UN REQUISITO
  async cambiarEstado(objReq) {
    if (localStorage.getItem('modUser') == 'true') {
      this.accion = 6;
      await this.instanciaRequisito(objReq.reqId, objReq.reqNombre, objReq.reqDetalle, objReq.genEstado == 1 ? 0 : 1, objReq.genPeriodo, objReq.becaId, objReq.genRegistro, '', 1);
      this.agregarRequisito();
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA MIGRAR UN REQUISITO
  async migraRequisito(objRequisito) {
    if (localStorage.getItem('modUser') == 'true') {
      this.srvInsert.ingresoGestionRequisitos(this.vecAddRequisito[0]['beca'], objRequisito.intIdRequisito, this.periodoCod, localStorage.getItem('ciUsuario'), 'na', 'na', 'na', 2, 9).subscribe(res => {
        if (res.requisito) {
          this.reiniciarTabla();
          this.cargarReqGenerales(1);
        }
      });
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //INSTANCIAR LAS VARIABLES 
  instanciaRequisito(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9) {
    this.vecAddRequisito = [];
    this.vecAddRequisito.push({
      idReq: dato1, nombre: dato2, detalle: dato3, estado: dato4, periodo: dato5, beca: dato6, rol: dato7, formulario: dato8, tipoReq: dato9
    });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblGeneral').DataTable({ destroy: true });
    table3.destroy();
  }
  //ABRIR EL MODAL QUE PERMITE VER EL FORMULARIO
  async verArchivoFormato(nombModal: any, rutaArchivo: any) {
    this.vecFormato = rutaArchivo;
    this.cargando.abrir();
    if (rutaArchivo.formulario != '') {
      this.rutaCarga = ''; this.enlaceCarga = '';
      this.rutaCarga = await this.srvGeneral.obtenerArchivoPDF(this.tokenDrive, rutaArchivo.formulario);
      this.enlaceCarga = await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, rutaArchivo.formulario);
    }
    else
      this.alerti.message('No contiene un formato este requisito');
    this.mr = this.modalService.open(nombModal);
    this.cargando.cerrar();
  }

  //FUNCION QUE OBTIENE EL FILE DEL DOCUMENTO A SUBIR
  async subirFormatoPDF(evento) {
    this.cargando.abrir();
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
    let rutaCarga = '';
    rutaCarga = 'Formato_Requisitos/Periodo_' + this.vecFormato.genPeriodo + '/TIPO_BECA_ID_' + this.vecFormato.becaId
      + '/ReqGeneral/Per_' + this.vecFormato.genPeriodo + '_Tipo_Beca_ID_' + this.vecFormato.becaId + '_NumReq_' + this.vecFormato.reqId + '.pdf';
    this.fileReq = evento.target.files[0];
    this.rutaCarga = evento.target.files[0];
    if (this.fileReq) {
      let formArchivo = new FormData();
      formArchivo.append('idAplicacion', this.recBecas.idAplicacion);
      formArchivo.append('idCredencial', "1");
      formArchivo.append('activo', "true");
      formArchivo.append('ruta', rutaCarga);
      formArchivo.append('file', this.fileReq);

      await this.srvInsert.subirArchivos(formArchivo, this.tokenDrive).subscribe(data => {
        if (data.success) {

          this.srvInsert.ingresoGestionRequisitos(this.vecFormato.becaId, this.vecFormato.reqId, this.vecFormato.genPeriodo, rutaCarga, 'na', 'na', 'na', 'na', 11).subscribe(res => {
            if (res.requisito) {
              this.alerti.success('subido el documento');
              this.reiniciarTabla();
              this.cargarReqGenerales(1);
            }
            else
              this.alerti.error("No se pudo ingresar el documento.");
          });

          this.cargando.cerrar();
        }
      });
    }
  }

  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
